import React from 'react';
import ComingSoon from '../../components/common/ComingSoon';

const icon = <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>;

const Reviews = () => (
  <ComingSoon
    title="İncelemeler"
    description="Ürün ve malzeme incelemelerinizi yazabileceğiniz, diğer mühendislerin değerlendirmelerini okuyabileceğiniz inceleme platformu yakında burada."
    icon={icon}
    activeId="feed_product_review"
  />
);

export default Reviews;
